export default __webpack_public_path__ + "static/media/daraga.687bdd50.jpg";